/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { AlertPlugin } from 'bootstrap-vue/esm/components/alert';
import { BadgePlugin } from 'bootstrap-vue/esm/components/badge';
import { ButtonPlugin } from 'bootstrap-vue/esm/components/button';
import { ButtonGroupPlugin } from 'bootstrap-vue/esm/components/button-group';
import { ButtonToolbarPlugin } from 'bootstrap-vue/esm/components/button-toolbar';
import { CardPlugin } from 'bootstrap-vue/esm/components/card';
import { CollapsePlugin } from 'bootstrap-vue/esm/components/collapse';
import { DropdownPlugin } from 'bootstrap-vue/esm/components/dropdown';
import { FormPlugin } from 'bootstrap-vue/esm/components/form';
import { FormCheckboxPlugin } from 'bootstrap-vue/esm/components/form-checkbox';
import { FormFilePlugin } from 'bootstrap-vue/esm/components/form-file';
import { FormGroupPlugin } from 'bootstrap-vue/esm/components/form-group';
import { FormRadioPlugin } from 'bootstrap-vue/esm/components/form-radio';
import { FormSelectPlugin } from 'bootstrap-vue/esm/components/form-select';
import { InputGroupPlugin } from 'bootstrap-vue/esm/components/input-group';
import { ListGroupPlugin } from 'bootstrap-vue/esm/components/list-group';
import { ModalPlugin } from 'bootstrap-vue/esm/components/modal';
import { NavPlugin } from 'bootstrap-vue/esm/components/nav';
import { PaginationPlugin } from 'bootstrap-vue/esm/components/pagination';
import { PopoverPlugin } from 'bootstrap-vue/esm/components/popover';
import { ProgressPlugin } from 'bootstrap-vue/esm/components/progress';
import { TablePlugin } from 'bootstrap-vue/esm/components/table';
import { TabsPlugin } from 'bootstrap-vue/esm/components/tabs';
import { ToastPlugin } from 'bootstrap-vue/esm/components/toast';
import { VBModalPlugin } from 'bootstrap-vue/esm/directives/modal';
import { VBPopoverPlugin } from 'bootstrap-vue/esm/directives/popover';
import { VBTogglePlugin } from 'bootstrap-vue/esm/directives/toggle';
import { VBVisiblePlugin } from 'bootstrap-vue/esm/directives/visible';
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import vueDebounce from 'vue-debounce';
// NOTE: We use ts-ignore-error instead of ts-expect-error in this file as jest
// seems to think that some `.vue` file imports are errors, while it is not an
// error while building the frontend.
// eslint-disable-next-line
// @ts-ignore-error
import VueMasonry from 'vue-masonry-css';
import CatchError from '@/components/CatchError';
import CgLogo from '@/components/CgLogo';
import Collapse from '@/components/Collapse';
import DescriptionPopover from '@/components/DescriptionPopover';
import CgError from '@/components/Error';
import Loader from '@/components/Loader';
import RelativeTime from '@/components/RelativeTime';
import WizardButton from '@/components/WizardButton';
Vue.component('cg-relative-time', RelativeTime);
Vue.component('cg-loader', Loader);
Vue.component('cg-description-popover', DescriptionPopover);
Vue.component('cg-logo', CgLogo);
Vue.component('cg-catch-error', CatchError);
Vue.component('cg-error', CgError);
Vue.component('cg-wizard-button', WizardButton);
Vue.component('cg-collapse', Collapse);
Vue.use(VueMasonry);
Vue.use(VueClipboard);
Vue.use(vueDebounce);
[
    AlertPlugin,
    BadgePlugin,
    ButtonPlugin,
    ButtonGroupPlugin,
    ButtonToolbarPlugin,
    CardPlugin,
    CollapsePlugin,
    DropdownPlugin,
    FormPlugin,
    FormCheckboxPlugin,
    FormFilePlugin,
    FormGroupPlugin,
    FormRadioPlugin,
    FormSelectPlugin,
    InputGroupPlugin,
    ListGroupPlugin,
    ModalPlugin,
    NavPlugin,
    PaginationPlugin,
    PopoverPlugin,
    ProgressPlugin,
    TabsPlugin,
    TablePlugin,
    ToastPlugin,
    VBPopoverPlugin,
    VBTogglePlugin,
    VBModalPlugin,
    VBVisiblePlugin,
].forEach(plugin => Vue.use(plugin));
